import React, { ReactNode, useContext, useCallback } from 'react';
import {
  withLocalization,
  withLocalizationProps,
  ConfigContext,
} from '../../context/Config';
import Text from '../Text';
import { SummeryType } from '../../types';
import Wrapper from '../Wrapper';
import isEmpty from 'lodash/isEmpty';
import './NextSessionCard.less';

type SessionType = {
  title?: string | ReactNode;
  groupTitle?: string;
  date?: string;
  groupLink?: string;
  trainingLinks?: { [key: string]: string };
};

export type { SessionType };

type NextSessionCardProps = {
  title?: string;
  session?: SessionType;
  size?: SummeryType;
  noSessionText: string;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TNextSessionCard: React.FC<
  NextSessionCardProps & withLocalizationProps
> = ({ title, session, noSessionText, moment }) => {
  const { translate } = useContext(ConfigContext);

  const getTimeLeft = useCallback(() => {
    const days = moment(session?.date).diff(moment(), 'day');
    if (days < 1) {
      const hours = moment(session?.date).diff(moment(), 'hour');
      if (hours < 1) {
        return `${moment(session?.date).diff(moment(), 'minutes')} ${translate(
          'minutes',
          {},
          false,
        )}`;
      }
      return `${hours} ${translate('hours', {}, false)}`;
    }
    return `${days} ${translate('days', {}, false)}`;
  }, [session]);

  return (
    <a
      href={session?.groupLink}
      className={isEmpty(session?.groupLink) ? 't-disableClick' : null}
    >
      <div className="t-nextSessionCard">
        <Wrapper display="flex" flexDirecton="column">
          <Text level={1} rows={1} bold>
            {title}
          </Text>
        </Wrapper>

        <Wrapper display="flex" flexDirecton="column">
          {session && (
            <Text level={2} rows={1} semiBold>
              {session.title}
            </Text>
          )}
        </Wrapper>

        <Wrapper display="flex" flexDirecton="column">
          {session?.date && (
            <Text level={4} rows={1}>
              {translate('will start in {{timeLeft}}', {
                timeLeft: getTimeLeft(),
              })}
            </Text>
          )}
          {!session?.date && (
            <Text level={4} rows={1}>
              {noSessionText}
            </Text>
          )}
        </Wrapper>
      </div>
    </a>
  );
};

export default withLocalization(TNextSessionCard);
